import Repository from './Repository'

export default {
  getToken (data) {
    return Repository.public().post(
      '/dashboard/login',
      data
    )
  }
}
